import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsShieldFilled = React.forwardRef(
  (props: SvgIconProps, ref: any) => {
    return (
      <SvgIcon {...props} ref={ref}>





        <g  fill="currentColor">
	<path d="M0.9965814,14.7715387c1.1787543,3.9503012,4.1855979,7.0928926,8.0770731,8.4481211l0.5995588,0.2058849
		V0.4522705L0.9377559,14.5769653L0.9965814,14.7715387z"/>
	<path d="M22.6101036,9.4501724c-1.160656-3.9412498-4.1471367-7.0838413-8.0227737-8.4481201L13.987772,0.7939039
		v22.9823265h0.000001L22.666666,9.6424837L22.6101036,9.4501724z"/>
</g>
      </SvgIcon>
    );
  }
);

export default AppIconsShieldFilled;
